import {
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import 'dayjs/locale/en-gb';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectMultipleTitles, selectTitle } from '../redux/reducers/catalogsReducer';
import { selectSelectedFrameworkControlIds } from '../redux/reducers/frameworkReducer';

function ControlItem({ controlId }) {
  const title = useSelector((state) => selectTitle(state, controlId));
  return (
    <ListItemText>
      <Typography variant="bold">{title}</Typography>
    </ListItemText>
  );
}

function ControlSelector({ handleControlsChange, controlsList = [], disabled }) {
  const { t } = useTranslation();
  const [showSelect, setShowSelect] = useState(false);
  const controls = useSelector(selectSelectedFrameworkControlIds);
  const [selectedControls, setSelected] = useState(controlsList);
  const controlTitles = useSelector((state) => selectMultipleTitles(state, selectedControls));

  useEffect(() => {
    if (controlsList.length === 0) {
      setSelected([]);
      handleControlsChange([]);
    }
  }, [controls]);

  const handleChange = (event) => {
    const { value } = event.target;
    setSelected(value);
  };

  const handleClose = () => {
    handleControlsChange(selectedControls);
    setShowSelect(false);
  };

  useEffect(() => {
    setSelected(controlsList);
  }, [controlsList]);

  return (
    <FormControl sx={{ pl: '16px' }}>
      <InputLabel shrink sx={{ ml: '16px', px: 1, backgroundColor: 'white' }} htmlFor="label">
        {t('activity.modal.relatedControls')}
      </InputLabel>
      <Select
        displayEmpty
        value={selectedControls}
        variant="outlined"
        disabled={disabled}
        MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
        open={showSelect}
        multiple
        onOpen={() => setShowSelect(true)}
        onClose={() => handleClose()}
        renderValue={(selected) => (
          selected.length > 0 ? (
            <Typography variant="bold">{controlTitles}</Typography>
          ) : (
            <Typography variant="regular">{t('control.selectControls')}</Typography>
          ))}
        onChange={handleChange}
      >
        {controls.map((controlId) => (
          <MenuItem id={controlId} key={controlId} value={controlId}>
            <ControlItem controlId={controlId} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default ControlSelector;
